import { MyPortfolioPage } from './MyPortfolioPage';

export default MyPortfolioPage;
